import { styled as a, CardContent as l } from "@mui/joy";
const i = a(l, {
  shouldForwardProp: (t) => !["justifyContent", "alignItems", "gap"].includes(t)
})(({
  theme: {
    spacing: t
  },
  alignItems: e,
  gap: n,
  justifyContent: o
}) => ({
  "&:last-child": {
    paddingBottom: 0
  },
  alignItems: e || "center",
  color: "initial",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: t(n || 0),
  justifyContent: o || "center",
  overflow: "auto",
  padding: 0
}));
i.displayName = "DqCardContent";
export {
  i as default
};
//# sourceMappingURL=DqCardContent.js.map
